import { configureStore } from "@reduxjs/toolkit";
import darkModeReducer from "./reducers/DarkModeReducer";
import expandableCardReducer from "./reducers/ExpandableCardReducer";
export default configureStore({
  reducer: {
    DarkMode: darkModeReducer,
    ExpandableCard: expandableCardReducer,
  },
});
